<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>

    <b-card class="formCard">
      <b-card-text>
        <b-row>
          <b-col md="6">
            <h4>Add New Client</h4>
          </b-col>
          <b-col md="6" class="text-right">
            <b-button @click="goBack" size="xxl" variant="outline-secondary">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button></b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col md="4" class="mx-auto">
            <label>Client Type<span class="error">*</span></label>
            <model-list-select :list="clientTypes" v-model="form.client_type" option-value="clientTypeVal"
              option-text="clientTypeText" placeholder="Select Type" :style="{
                borderColor: !form.client_type && errorList.client_type ? 'red' : '',
              }"></model-list-select>

            <span class="error" v-if="!form.client_type && errorList.client_type">{{ errorList.client_type }}
            </span>
          </b-col>
          <b-col md="4" class="mx-auto">
            <label>Client Name<span class="error">*</span></label>
            <b-form-input id="client-name" v-model="form.client_name" required :style="{
              borderColor: !form.client_name && errorList.client_name ? 'red' : '',
            }" />
            <span class="error" v-if="!form.client_name && errorList.client_name">{{ errorList.client_name }}
            </span>
          </b-col>
          <b-col md="4" class="mx-auto">
            <label>Email<span class="error">*</span></label>
            <b-form-input id="client-email" @keyup="isEmailValid" type="email" v-model="form.email" required :style="{
              borderColor:
                (!form.email && errorList.email) || errorEmailFormat ? 'red' : '',
            }" />
            <span class="error" v-if="!form.email && errorList.email">{{ errorList.email }}
            </span>
            <span class="error" v-if="!form.email">{{ emailError }}</span>
            <span class="error" v-if="form.email">{{ errorEmailFormat }}</span>
          </b-col>

          <b-col md="4" class="mx-auto">
            <label>Mobile Number<span class="error">*</span></label>
            <b-form-input id="client-mobile" type="text" v-model="form.mobile" required @input="isMobileValid" :style="{
              borderColor:
                (!form.mobile && errorList.mobile) || errorMobileFormat ? 'red' : '',
            }" />
            <span class="error" v-if="!form.mobile && errorList.mobile">{{ errorList.mobile }}
            </span>
            <span class="error" v-if="form.mobile && errorMobileFormat">>{{ errorMobileFormat }}</span>
          </b-col>
          <b-col md="4" class="mx-auto">
            <label>TAN No (AAAA12345A)<span class="error">*</span></label>
            <input :id="'is_not_tan'" name="checkbox-tan" type="checkbox" v-model="form.is_not_tan" value="1"
              class="mt-5" unchecked-value="0" @change="TANErrorValid()" />
            
            <span class="error">Not Applicable</span>
            <b-form-input id="client-tan" v-model="form.tan" @keyup="form.is_not_tan == 1 ? '' : TANErrorValid()"
              :style="{
                borderColor:
                  (!form.tan && errorList.tan) || TANErrorValidErr || tanNOError
                    ? 'red'
                    : '',
              }" />
            <span class="error" v-if="!form.tan && errorList.tan">{{ errorList.tan }}
            </span>
            <span class="error" v-if="!form.tan">{{ tanNOError }}</span>
            <span class="error" v-if="TANErrorValidErr">{{ TANErrorValidErr }}</span>
          </b-col>
          <!-- <b-col md="4" class="mx-auto">
            <label>PAN No (AAAAA1234A)<span class="error">*</span></label>
            <b-form-input
              id="client-pan"
              v-model="form.pan"
              required
              @keyup="PANErrorValid()"
              :style="{
                borderColor:
                  (!form.pan && errorList.pan) || PANErrorValidErr ? 'red' : '',
              }"
            />
            <span class="error" v-if="!form.pan && errorList.pan"
              >{{ errorList.pan }}
            </span>
            <span class="error" v-if="!form.pan">{{ panNOError }}</span>
            <span class="error" v-else>{{ PANErrorValidErr }}</span>
          </b-col> -->
          <!-- <b-col md="4" class="mx-auto">
            <label>GST No (AAAAA1234A1Z5)<span class="error"></span></label>
            <b-form-input
              id="client-gst"
              v-model="form.gst"
              @keyup="GSTNErrorValid()"
              :style="{
                borderColor:
                  (!form.gst && errorList.gst) || GSTNErrorValidErr ? 'red' : '',
              }"
            />
            <span class="error" v-if="!form.gst && errorList.gst"
              >{{ errorList.gst }}
            </span>
            <span class="error" v-if="!form.gst">{{ GSTNError }}</span>
            <span class="error" v-else>{{ GSTNErrorValidErr }}</span>
          </b-col>
          <b-col md="4" class="mx-auto">
            <label>IEC No</label>
            <b-form-input id="client-iec" v-model="form.iec" />
          </b-col>
          
          <b-col md="4" class="mx-auto">
            <label>Client Address</label>
            <b-form-textarea id="client-address" v-model="form.client_address" required />
          </b-col> -->

          <!-- <b-col md="4">
            <label>
              Contact Designation
              <span class="error">*</span>
            </label>
            <model-list-select
              :list="accountList"
              id="kam_designation"
              v-model="form.kam_designation"
              :style="{
                borderColor:
                  !form.kam_designation && errorList.kam_designation ? 'red' : '',
              }"
              option-value="value"
              option-text="text"
              :placeholder="`Please Select Contact Designation `"
            ></model-list-select>
            <span class="error" v-if="!form.kam_designation">
              {{ errorList.kam_designation }}
            </span>
          </b-col> -->
          <b-col md="4">
            <label>
              Contact Name
              <span class="error">*</span>
            </label>
            <b-form-input :formatter="capitalizeAll" id="kam_name" name="kam_name" v-model="form.kam_name"
              :placeholder="`Please Enter Contact Name `" type="text" :style="{
                borderColor: !form.kam_name && errorList.kam_name ? 'red' : '',
              }"></b-form-input>
            <span class="error" v-if="!form.kam_name">
              {{ errorList.kam_name }}
            </span>
          </b-col>
          <b-col md="4">
            <label>
              Contact Email
              <span class="error">*</span>
            </label>
            <b-form-input :formatter="capitalizeAll" id="kam_email" name="kam_email" @keyup="isKamEmailValid"
              v-model="form.kam_email" :placeholder="`Please Enter Contact Email ID `" type="email" :style="{
                borderColor:
                  (!form.kam_email && errorList.kam_email) || errorKamEmailFormat
                    ? 'red'
                    : '',
              }"></b-form-input>
            <span class="error" v-if="!form.kam_email">
              {{ errorList.kam_email }}
            </span>
            <span class="error" v-if="form.kam_email">{{ errorKamEmailFormat }}</span>
          </b-col>
          <b-col md="4">
            <label>
              Contact Mobile
              <span class="error">*</span>
            </label>
            <b-form-input :formatter="capitalizeAll" id="kam_mobile" name="kam_mobile" @keyup="isKamMobileValid"
              v-model="form.kam_mobile" :placeholder="`Please Enter Contact Mobile No. `" type="number" :style="{
                borderColor:
                  (!form.kam_mobile && errorList.kam_mobile) || errorKamMobileFormat
                    ? 'red'
                    : '',
              }"></b-form-input>
            <span class="error" v-if="!form.kam_mobile">
              {{ errorList.kam_mobile }}
            </span>
            <span class="error" v-if="form.kam_mobile">{{ errorKamMobileFormat }}</span>
          </b-col>
          <b-col md="4" class="mx-auto">
            <label>Remark</label>
            <b-form-textarea id="Remark" v-model="form.client_remark" required />
          </b-col>

          <!-- New Questionnaire Section -->

          <b-col md="4">
            <label>
              Will the Client deal with us for EXPORT / IMPORT OR Both?
              <span class="error">*</span>
            </label>
            <model-list-select class="ml-1" :list="moduelTypeClientList" id="quest_export_import"
              v-model="form.quest_export_import" option-value="value" option-text="text"
              placeholder="Select Client deal Type" :style="{
                borderColor:
                  !form.quest_export_import && errorList.quest_export_import ? 'red' : '',
              }"></model-list-select>
            <span class="error" v-if="!form.quest_export_import">
              {{ errorList.quest_export_import }}
            </span>
          </b-col>
          <b-col md="4">
            <label>
              CC
              <span class="error">*</span>
            </label>
            <model-list-select class="ml-1" :list="CCList" id="quest_cc" v-model="form.quest_cc" option-value="val"
              option-text="text" placeholder="Select CC Type" :style="{
                borderColor: !form.quest_cc && errorList.quest_cc ? 'red' : '',
              }"></model-list-select>
            <span class="error" v-if="!form.quest_cc">
              {{ errorList.quest_cc }}
            </span>
          </b-col>

          <b-col md="4">
            <label>
              FF
              <span class="error">*</span>
            </label>
            <model-list-select class="ml-1" :list="CCList" id="quest_ff" v-model="form.quest_ff" option-value="val"
              option-text="text" placeholder="Select FF Type" :style="{
                borderColor: !form.quest_ff && errorList.quest_ff ? 'red' : '',
              }"></model-list-select>
            <span class="error" v-if="!form.quest_ff">
              {{ errorList.quest_ff }}
            </span>
          </b-col>
          <b-col md="4" v-if="form.quest_ff == '1'">
            <label>Container Type</label>
            <model-list-select :list="$store.getters['common/getAllContainerTypeList']"
              v-model="form.quest_cont_type_id" option-value="containerTypeId" option-text="containerType"
              placeholder="Select Container Type"></model-list-select>
            <span class="error" v-if="
              (form.quest_cont_type_id == undefined ||
                form.quest_cont_type_id == 'undefined' ||
                form.quest_cont_type_id == null ||
                form.quest_cont_type_id == 'null' ||
                form.quest_cont_type_id == '') &&
              form.is_nomination_shipper == false
            ">
              {{ errorList.quest_cont_type_id || "Container Type Fields is Required" }}
            </span>
          </b-col>
          <b-col md="4" v-if="form.quest_ff == '1'">
            <label>
              Define monthly volume in Containers Wise or TEUS
              <span class="error">*</span>
            </label>
            <b-form-input v-model="form.quest_monthly_volume" placeholder="Enter monthly volume"
              type="number"></b-form-input>
            <span class="error" v-if="
              (form.quest_monthly_volume == undefined ||
                form.quest_monthly_volume == 'undefined' ||
                form.quest_monthly_volume == null ||
                form.quest_monthly_volume == 'null' ||
                form.quest_monthly_volume == '') &&
              form.is_nomination_shipper == false
            ">
              {{
                errorList.quest_monthly_volume ||
                "Define monthly volume in Containers Wise or TEUS Fields is Required"
              }}
            </span>
          </b-col>
          <b-col md="4" v-if="form.quest_ff == '1'">
            <input :id="'is_nomination_shipper'" name="checkbox-1" type="checkbox" v-model="form.is_nomination_shipper"
              value="1" class="mt-5" unchecked-value="0" />

            <span class="error">NOMINATION SHIPPER</span>
          </b-col>
          <b-col md="4" v-else-if="form.quest_ff == '0'">
            <label>
              FF NA Reason
              <span class="error">*</span>
            </label>
            <model-list-select class="ml-1" :list="FFNAReasonList" id="ffOption" v-model="form.quest_ff_option"
              option-value="val" option-text="text" placeholder="Select FF NA Reason"></model-list-select>

            <span class="error" v-if="!form.quest_ff_option">
              {{ errorList.quest_ff_option }}
            </span>
          </b-col>

          <b-col md="12" class="mx-auto" v-if="form.client_name">
            <label>Client Document</label>
            <ClientFileUploader :style="'height: 80px; background: darkgray; width: 100%'"
              :documentName="'Client_Multiple_Doc-'" :otherDocName="'Client_Multiple_Doc-'" :folderName="'CLIENTKYCDOC'"
              :accept="'*'" :assign_no="'CLIENTKYCDOC'" :multiple="true" v-model="form.client_doc"
              :state="Boolean(form.client_doc)" :fileAllModuleId="'0'" />
          </b-col>
          <b-col md="12" v-if="form.client_doc">
            <div v-if="form.client_doc">
              <b-button v-for="(item1, index) in form.client_doc.split(',')" :key="index"
                style="margin-left: 2px; font-size: 0.675rem" @click="item1 ? PrintValidity_Doc(item1) : ''" size="sm"
                variant="warning" class="mb-1">{{ item1 ? "PDF" + (parseInt(index) + 1) : "" }}</b-button>
            </div>
          </b-col>
          <span class="error" v-if="clientDocError">{{ clientDocError }}</span>
        </b-row>
        <hr />
        <b-row>
          <b-col md="12" class="mx-auto text-center">
            <b-button @click="goBack" size="xxl" variant="outline-danger">
              Back
            </b-button>
            <b-button v-if="form.client_kyc_is_converted == 0 && isLoading == false" @click="saveClientKyc" size="xxl"
              variant="outline-success">
              Save
            </b-button>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import ClientFileUploader from "../common/ClientFileUploader.vue";
import CustomLoader from "../common/customLoader.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { lastVisitPage } from "../../helper/collection";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import Multiselect from "vue-multiselect";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import AccountService from "../../services/AccountService.js";
export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllContainerTypeList",
      JSON.stringify({
        itemCode: "ContainerTypeList",
      })
    );
    lastVisitPage(this.$router.history.current.fullPath);
    if (
      this.$sessionsStorage.get("editClientKycId") != undefined &&
      this.$sessionsStorage.get("editClientKycId") != null &&
      this.$sessionsStorage.get("editClientKycId") != ""
    ) {
      this.getClientKycList("Normal", this.$sessionsStorage.get("editClientKycId"));
    }

    this.$store.dispatch("setCurrentRoute", "/kyc-temp/addClientKyc");
    this.windowSize = $(window).width();
  },
  data() {
    return {
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      docURL: URL_BASE_DOC,
      isLoading: false,
      alert: {
        content: "",
        ok: "ok",
      },

      formError: [
        "Please Select Client Type",
        "Please Enter Client Name",
        // "Please Enter PAN No",
        // "Please Enter TAN No",
        "Please Enter Email ID.",
        "Please Enter Mobile No.",
        "Please Enter Contact Mobile No.",
        "Please Enter Contact Email ID.",
        "Please Enter Contact Name",
        // "Please Enter Contact Designation ",
        "Please Enter Client Deal ",
        "Please Enter FF Service ",
        "Please Enter CC Service ",
      ],
      errorList: {
        client_type: "",
        client_name: "",
        // pan: "",
        // tan: "",
        email: "",
        mobile: "",

        kam_mobile: "",
        kam_email: "",
        kam_name: "",
        // kam_designation: "",
        quest_export_import: "",
        quest_cc: "",
        quest_ff: "",
        is_nomination_shipper: false,
      },
      form: {
        client_kyc_is_converted: 0,
        kyc_id: 0,
        kyc_no: "",
        client_type: "",
        client_name: "",
        client_address: "",
        client_remark: "",
        gst: "",
        pan: "",
        iec: "",
        tan: "",
        is_not_tan: 0,
        client_doc: "",
        email: "",
        mobile: "",

        kam_mobile: "",
        kam_email: "",
        kam_name: "",
        kam_designation: "",

        // New questionnaire fields
        quest_cont_type_id: "",
        quest_export_import: "",
        quest_cc: null,
        quest_ff: null,
        quest_monthly_volume: "",
        quest_ff_option: "",
        is_nomination_shipper: false,
      },
      FFNAReasonList: [
        // {
        //   val: "0",
        //   text: "NOMINATION SHIPPER",
        // },
        {
          val: "1",
          text: "ALL NOMINATION",
        },
        {
          val: "2",
          text: "ALL DIRECT SLINE CONTRACTS",
        },
      ],
      CCList: [
        {
          val: "1",
          text: "Yes",
        },
        {
          val: "0",
          text: "No",
        },
      ],
      accountList: [
        {
          text: "SALES",
          value: "SALES",
        },
        {
          text: "LOGISTICS OPERATIONS",
          value: "LOGISTICS OPERATIONS",
        },
        {
          text: "ACCOUNTS",
          value: "ACCOUNTS",
        },
        {
          text: "OWNER",
          value: "OWNER",
        },
        {
          text: "DIRECTOR",
          value: "DIRECTOR",
        },
        {
          text: "CFO",
          value: "CFO",
        },
        {
          text: "COO",
          value: "COO",
        },
        {
          text: "CEO",
          value: "CEO",
        },
        {
          text: "MANAGER",
          value: "MANAGER",
        },
        {
          text: "ASST. MANAGER",
          value: "ASST. MANAGER",
        },
      ],
      moduelTypeClientList: [
        {
          text: "Export",
          value: "Export",
        },
        {
          text: "Import",
          value: "Import",
        },
        {
          text: "Both",
          value: "Both",
        },
      ],
      clientTypes: [
        { clientTypeVal: null, clientTypeText: "Please Select Client Type" },
        {
          clientTypeVal: "Client",
          clientTypeText: "Client",
        },

        {
          clientTypeVal: "Overseas",
          clientTypeText: "Overseas",
        },
        // {
        //   clientTypeVal: "Lead",
        //   clientTypeText: "Lead",
        // },
        {
          clientTypeVal: "Transporter",
          clientTypeText: "Transporter",
        },
        {
          clientTypeVal: "Trader",
          clientTypeText: "Trader",
        },
        {
          clientTypeVal: "Freight_Forwarder",
          clientTypeText: "Freight Forwarder",
        },
      ],
      tanNOError: "",
      GSTNError: "",
      GSTNErrorValidErr: "",
      TANErrorValidErr: "",
      errorEmailFormat: "",
      emailError: "",
      panNOError: "",
      PANErrorValidErr: "",
      errorMobileFormat: "",
      errorKamEmailFormat: "",
      errorKamMobileFormat: "",
      validate: false,
      shipmentType_items: [],
      clientDocError: "",
    };
  },
  created() {
    eventBus.$on("fileuploaded", (file) => {
      console.log("fileuploaded=>", file);
      this.form.client_doc = file;
    });
  },
  mounted() { },
  computed: {
    isSeaShipment() {
      // Check if lead_shipmentType is an array and contains an object with value 'Sea'
      return (
        Array.isArray(this.shipmentType_items) &&
        this.shipmentType_items.some((item) => item.value === "Sea")
      );
    },
  },

  destroyed() { },
  components: {
    ModelListSelect,
    MultiSelect,
    CustomLoader,
    Multiselect,
    ClientFileUploader,
  },
  methods: {
    goBack() {
      window.history.go(-1);
    },
    isEmailValid() {
      let emailreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

      if (emailreg.test(this.form.email)) {
        this.errorEmailFormat = "";
      } else {
        this.errorEmailFormat = "Enter Valid Email";
      }
    },
    isKamEmailValid() {
      let emailreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

      if (emailreg.test(this.form.email)) {
        this.errorKamEmailFormat = "";
      } else {
        this.errorKamEmailFormat = "Enter Valid Email";
      }
    },
    isMobileValid() {
      // const mobilereg = /^\d{10}$/;
      // console.log("mobilereg.test(this.form.mobile)=>", mobilereg.test(this.form.mobile));
      // if (mobilereg.test(this.form.mobile)) {
      if (mobileNumber.length == 10) {
        this.errorMobileFormat = "";
      } else {
        this.errorMobileFormat = "Enter Valid Mobile Number";
      }
    },
    isKamMobileValid() {
      const mobileNumber = this.form.kam_mobile.replace(/\D/g, "").trim() || "";
      // alert(mobileNumber)
      const mobilereg = /^\d{10}$/;
      console.log("mobilereg.test(this.form.mobile)=>", mobilereg.test(mobileNumber));
      // alert(mobileNumber.length)
      // if (mobileNumber.length == 10) {
        if (mobilereg.test(mobileNumber)) {
        this.errorKamMobileFormat = "";
      } else {
        this.errorKamMobileFormat = "Enter Valid Mobile Number";
      }
    },
    GSTNErrorValid() {
      // var gstinformat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$");
      var gstinformat = new RegExp(
        "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
      );

      if (gstinformat.test(this.form.gst)) {
        this.GSTNErrorValidErr = "";
      } else {
        this.GSTNErrorValidErr = "Please Enter Valid GSTN";
      }
    },
    PANErrorValid() {
      var paninformat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$");

      if (paninformat.test(this.form.pan)) {
        this.PANErrorValidErr = "";
      } else {
        this.PANErrorValidErr = "Please Enter Valid PAN No.";
      }
    },
    TANErrorValid() {
      var taninformat = new RegExp("^[A-Z]{4}[0-9]{5}[A-Z]{1}$");
      console.log("taninformat.test(this.form.tan)=>", taninformat.test(this.form.tan),this.form);
      if (this.form.is_not_tan == 1 || this.form.is_not_tan == true) {
        this.TANErrorValidErr = "";
      } else {
        if (taninformat.test(this.form.tan)) {
          this.TANErrorValidErr = "";
        } else {
          this.TANErrorValidErr = "Please Enter Valid TAN No.";
        }
      }
    },
    validateClient() {
      let validate_new = true;
      this.TANErrorValid();
      Object.keys(this.errorList).map((x, index) => {
        console.log("this.X=>", x);
        console.log("this.form[x]=>", this.form[x]);
        if (this.form[x] == "" || this.form[x] == undefined || this.form[x] == null) {
          if (x !== "is_nomination_shipper") {
            this.errorList[x] = this.formError[index];
            validate_new = false;
          }
        }
      });

      // Document upload validation only on edit
      if (
        // (this.form.kyc_id && this.form.kyc_id !== 0) && // Only if editing
        (!this.form.client_doc || this.form.client_doc.trim() === "")
      ) {
        this.clientDocError = "Please upload at least one document.";
        validate_new = false;
      } else {
        this.clientDocError = "";
      }

      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },
    goClientKycPage() {
      this.$router.push({
        path: "/client/clientKycTempList",
      });
    },
    PrintValidity_Doc(validity_doc) {
      this.openSignedDocument(`CLIENTKYCDOC/${validity_doc}`);
    },
    saveClientKyc() {
      this.validateClient();
      if (this.validate) {
        // Handle form submission
        console.log(this.form);
        this.errorList.quest_cont_type_id = "";
        this.errorList.quest_monthly_volume = "";
        if (
          this.form.is_nomination_shipper == false ||
          this.form.is_nomination_shipper == 0 ||
          this.form.is_nomination_shipper == undefined ||
          this.form.is_nomination_shipper == "undefined"
        ) {
          this.form.is_nomination_shipper = "0";
          if (this.form.quest_ff == "1") {
            if (
              this.form.quest_cont_type_id == "" ||
              this.form.quest_cont_type_id == undefined ||
              this.form.quest_cont_type_id == null ||
              this.form.quest_cont_type_id == "undefined"
            ) {
              this.errorList.quest_cont_type_id = "Container Type Fields is Required";
              return false;
            }
            if (
              this.form.quest_monthly_volume == "" ||
              this.form.quest_monthly_volume == undefined ||
              this.form.quest_monthly_volume == null ||
              this.form.quest_monthly_volume == "undefined"
            ) {
              this.errorList.quest_monthly_volume =
                "Define monthly volume in Containers Wise or TEUS Fields is Required";
              return false;
            }
          }
        } else {
          this.form.is_nomination_shipper = "1";
        }

        this.isLoading = true;
        let payload = {
          itemCode: "upsertClientKyc",
          clientDet: this.form,
        };
        AccountService.getAllClientKycList(payload)
          .then((response) => {
            const { data, status, statusText } = response;

            if (status == 200 && data) {
              this.alert.content = data.MSG;
              this.$refs["addPop"].open();
              this.goClientKycPage();
            }

            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on saveClientKyc Error: ", error);
          });
      } else {
        // Show validation errors to the user
        console.log("Validation errors:", this.errorList);
      }
    },

    getClientKycList(type, kyc_id) {
      this.getClientKycList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getClientKycList",
        type: type,
        DCfilterId: "",
        searchVal: "",
        DCfilterId: "",
        fromSearch: "",
        currentPage: "",
        perPage: "0",
        Filter: {},
        kyc_id: kyc_id,
      };

      AccountService.getAllClientKycList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.getClientKycList.length > 0) {
              this.form = data.getClientKycList[0];
              this.form.tan = data.getClientKycList[0].tanNO;
              this.form.is_nomination_shipper = (data.getClientKycList[0].is_nomination_shipper) == 0 ? false : true;
              this.form.is_not_tan = (data.getClientKycList[0].is_not_tan) == 0 ? false : true;
              console.log("this.form+", this.form)
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getPrerequisiteList Error: ", error);
        });
    },
  },
};
</script>

<style>
body {
  background-color: #f8f9fa;
}

.b-container {
  margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// addClientKyc.vue?5bc29ff8